module.exports = __webpack_public_path__ + "media/images/flags/1x1/myt-237a41619f1f8f2c17481ceb853086ff.svg";